/* ==================================================
  c_staff-pdp-block.js — 商品詳細の「Web限定」（客注モード専用）
  spec: 03_客注モード_FE §2.6.4 / §2.6.5 No.1
  - 客注モード（CStaffSession のトークンあり）のときだけ動く。通常の EC では何もしない。
  - 判定データは section ルート（[data-staff-pdp-block][data-web-limited]）にある。variant 切替で
    product-rerender が差し替わっても section ルートは残る。
  - 購入制限対象で在庫がある SKU 行（snippets/c_sku-cart-add.liquid）では、数量選択と「カートに追加」を隠して
    「Web限定」ラベルを出す。在庫切れ・完売の行は購入制限対象でも通常の EC と同じ表示のまま
    （「店舗在庫確認」と「再入荷通知」または「売り切れ」）。在庫の有無は Liquid の判定（variant.available）に従い、
    行に「カートに追加」があるかで見る。
  - 全 SKU が購入制限対象で、かつ全 SKU に在庫がある商品だけ、SP の SKU 一覧を開くボタン（#SkuCartTrigger）と
    画面下の追従ボタン（#SkuCartStickyBar 内の #StickyAddToCart）を非活性にして文言を「Web限定」にする。
    在庫切れ・完売の SKU が 1 つでもあれば、一覧から再入荷通知・店舗在庫確認を使えるようボタンはそのまま。
  - 予約商品テンプレートなど form[is=product-form] のボタンは c_web-limited-cart-add-guard.js が扱う。
  - ページはキャッシュされるため判定はブラウザの JST 当日日付で行い、bfcache 復元時も判定し直す。
  ===================================================*/
(function () {
  'use strict';

  var HIDDEN_CLASS = 'c_web-limited-hidden';
  var DISABLED_CLASS = 'c_web-limited-disabled';
  var CONTROLS = '.js-quantity-select, .js-add-to-cart';
  var IN_STOCK_CONTROL = '.js-add-to-cart';
  var MOBILE_TRIGGERS = '#SkuCartTrigger, #SkuCartStickyBar #StickyAddToCart';

  function applyRows() {
    var W = window.CWebLimited;
    var staff = W.isStaffMode();
    var labels = document.querySelectorAll('[data-web-limited-sku]');
    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      var id = label.getAttribute('data-web-limited-sku');
      var container = label.parentNode;
      var restricted = staff && inStock(container) && W.isVariantRestricted(W.dataFor(label, id), id);
      label.hidden = !restricted;
      var controls = container ? container.querySelectorAll(CONTROLS) : [];
      for (var j = 0; j < controls.length; j++) {
        controls[j].classList.toggle(HIDDEN_CLASS, restricted);
        if (restricted) controls[j].setAttribute('aria-hidden', 'true');
        else controls[j].removeAttribute('aria-hidden');
      }
    }
  }

  /* Liquid は在庫がある SKU の行にだけ「カートに追加」を出す（在庫切れ・完売の行は店舗在庫確認と再入荷通知・売り切れ） */
  function inStock(container) {
    return !!(container && container.querySelector(IN_STOCK_CONTROL));
  }

  function everySkuInStock() {
    var labels = document.querySelectorAll('[data-web-limited-sku]');
    if (!labels.length) return false;
    for (var i = 0; i < labels.length; i++) {
      if (!inStock(labels[i].parentNode)) return false;
    }
    return true;
  }

  /* 文言は元の子ノードそのものを退避して戻す（c_web-limited-cart-add-guard.js と同じやり方） */
  function blockTrigger(btn) {
    if (btn.classList.contains(DISABLED_CLASS)) return;
    btn.__cWebLimitedState = { nodes: Array.prototype.slice.call(btn.childNodes), disabled: btn.disabled };
    btn.classList.add(DISABLED_CLASS);
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = window.CWebLimited.labels().all;
  }

  function releaseTrigger(btn) {
    var state = btn.__cWebLimitedState;
    if (!state) return;
    btn.classList.remove(DISABLED_CLASS);
    while (btn.firstChild) btn.removeChild(btn.firstChild);
    state.nodes.forEach(function (node) { btn.appendChild(node); });
    btn.disabled = state.disabled;
    if (!state.disabled) btn.removeAttribute('aria-disabled');
    btn.__cWebLimitedState = null;
  }

  function applyTriggers() {
    var W = window.CWebLimited;
    var root = document.querySelector('[data-staff-pdp-block]');
    var allRestricted = W.isStaffMode() && !!root && W.productStatus(W.dataOf(root)) === 'all' && everySkuInStock();
    var buttons = document.querySelectorAll(MOBILE_TRIGGERS);
    for (var i = 0; i < buttons.length; i++) {
      if (allRestricted) blockTrigger(buttons[i]);
      else releaseTrigger(buttons[i]);
    }
  }

  function apply() {
    if (!window.CWebLimited) return;
    applyRows();
    applyTriggers();
  }

  function init() {
    if (!window.CWebLimited || !window.CWebLimited.isStaffMode()) return;
    apply();
    /* SKU 行は variant 切替・カート追加後の再描画で差し替わることがあるため、行の追加を拾い直す */
    var root = document.querySelector('[data-staff-pdp-block]');
    if (root && typeof MutationObserver === 'function') {
      var timer = null;
      new MutationObserver(function () {
        if (timer) return;
        timer = setTimeout(function () {
          timer = null;
          apply();
        }, 50);
      }).observe(root, { childList: true, subtree: true });
    }
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) apply();
    });
    document.addEventListener('shopify:section:load', apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
